var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScoringFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.49994 2.5C8.33644 2.5 8.17252 2.57089 8.08002 2.71289L6.02239 5.8838L2.37004 6.86134C2.20654 6.90484 2.07684 7.02797 2.02434 7.18947C1.97233 7.35047 2.00475 7.52769 2.11125 7.65919L4.49114 10.5967L4.2929 14.3711C4.2839 14.5401 4.36097 14.7023 4.49798 14.8018C4.53756 14.8307 4.58192 14.8514 4.62688 14.8672C4.63972 14.8717 4.65282 14.8735 4.66594 14.877C4.69945 14.8858 4.73294 14.8919 4.76751 14.8936C4.77577 14.894 4.78364 14.8975 4.79192 14.8975C4.79915 14.8975 4.80617 14.8939 4.81341 14.8936C4.86695 14.8914 4.9202 14.8838 4.97161 14.8643L8.49994 13.5098L12.0292 14.8643C12.0872 14.8863 12.1475 14.8975 12.208 14.8975C12.312 14.8975 12.4154 14.8648 12.5019 14.8018C12.6389 14.7023 12.716 14.5401 12.707 14.3711L12.5097 10.5967L14.8886 7.65919C14.9946 7.52769 15.028 7.35047 14.9755 7.18947C14.923 7.02847 14.7933 6.90534 14.6298 6.86134L10.9775 5.8838L8.91986 2.71289C8.82786 2.57089 8.66344 2.5 8.49994 2.5Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoringFull);
export default __webpack_public_path__ + "static/media/scoringFull.102dc1081923bd775c8b0c4e441253a1.svg";
export { ForwardRef as ReactComponent };